module.exports = __webpack_public_path__ + "8ab2fff9bbcca86e325ae817624db985.png";